import { RadioChangeEvent, Space } from 'antd';
import { Radio } from '@maxtropy/components';
import { FC, useState } from 'react';
import { V2RuleAlarmLogAlarmLevelCountPostResponse } from '@maxtropy/tody-mgmt-apis-v2';
import styles from './index.module.scss';
import { GradeEnum } from '../utils';

export interface DateSwitchProps {
  gradeDatas: V2RuleAlarmLogAlarmLevelCountPostResponse;
  setLevels?: (levels: number[]) => void;
}

const GradeSwitch: FC<DateSwitchProps> = props => {
  const { gradeDatas, setLevels } = props;
  const [grade, setGrade] = useState(GradeEnum.ALL);

  const onRadioChange = (e: RadioChangeEvent) => {
    setGrade(e.target.value);
    e.target.value !== GradeEnum.ALL ? setLevels?.([e.target.value]) : setLevels?.([]);
  };

  return (
    <Space className={styles.dateSwitch} size={16}>
      <Space>
        <Radio.Group onChange={onRadioChange} value={grade} buttonStyle="solid">
          <Radio.Button value={GradeEnum.ALL}>全部({gradeDatas?.total ?? 0})</Radio.Button>
          <Radio.Button value={GradeEnum.TOP}>最高级({gradeDatas?.topLevel ?? 0})</Radio.Button>
          <Radio.Button value={GradeEnum.HIGH}>高级({gradeDatas?.highLevel ?? 0})</Radio.Button>
          <Radio.Button value={GradeEnum.MIDDLE}>中级({gradeDatas?.middleLevel ?? 0})</Radio.Button>
          <Radio.Button value={GradeEnum.LOW}>低级({gradeDatas?.lowLevel ?? 0})</Radio.Button>
          <Radio.Button value={GradeEnum.LOWEST}>最低级({gradeDatas?.lowestLevel ?? 0})</Radio.Button>
        </Radio.Group>
      </Space>
    </Space>
  );
};

export default GradeSwitch;
